import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchPackage } from '../redux/features/packages/packageSlice';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import {
  getFallbackPlanImage,
  getPlanOptionsByFrequency,
  getPrimaryPlanOption,
} from '../utils/planAdapter';

const PackagePlan = () => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.package.packages);
  const navigate = useNavigate();
  const { personalDetail } = useSelector((state) => state.signup);
  // const [registrationFee, setRegistrationFee] = useState(0);
  const [isPlan, setIsPlan] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      dispatch(fetchPackage());
    };
    fetchData();
  }, []);

  useEffect(() => {
    if (!data) {
      return;
    }
  }, [data]);

  const handlePlan = (plan) => {
    const selectedFrequency = isPlan ? 'yearly' : 'monthly';
    const selectedOption = getPrimaryPlanOption(plan, selectedFrequency, {
      includePrepaid: false,
      includeLifetimeFallback: true,
    });

    localStorage.setItem('selectedPlan', JSON.stringify(plan));
    localStorage.setItem('selectedTerm', !isPlan ? 'month' : 'year');

    if (selectedOption?.frequency === 'lifetime') {
      localStorage.setItem('selectedPlanType', 'Lifetime');
    } else {
      localStorage.setItem('selectedPlanType', !isPlan ? 'Monthly' : 'Yearly');
    }

    if (
      personalDetail?.subscriptions?.length === 0 &&
      Cookies.get('isSubscribed') === undefined
    ) {
      localStorage.setItem('joinEmail', personalDetail?.email);
      navigate('/plan-checkout');
    } else {
      navigate('/joinform');
    }
  };

  // Renders dynamic option prices for the currently selected term.
  const renderPriceDetails = (plan, isYearlySelected) => {
    const selectedFrequency = isYearlySelected ? 'yearly' : 'monthly';

    return getPlanOptionsByFrequency(plan, selectedFrequency, {
      includePrepaid: false,
      includeLifetimeFallback: true,
    }).map((price, id) => (
      <div className="price-dcpt" key={id}>
        <h5 className="description-price">
          ${price.price + ' '}
          <span className="font-c">{price.description}</span>
          <br />
          <span>
            {isYearlySelected
              ? 'Unlimited access to our indoor, outdoor and shotgun ranges during business hours.'
              : price?.package_description}
          </span>
        </h5>
      </div>
    ));
  };

  // Renders the card image based on the membership type.
  const renderCardImage = (item) => {
    const imageSrc = item?.card_image_url || getFallbackPlanImage(item);

    return imageSrc ? (
      <div className="card-img-price">
        <img
          src={imageSrc}
          className="card-img-top img-fluid"
          alt={`${item.name} Member Card`}
        />
      </div>
    ) : null;
  };

  // Renders the plan cards based on the provided data and plan type.
  const renderPlanCards = (plans, isYearlySelected) => {
    const selectedFrequency = isYearlySelected ? 'yearly' : 'monthly';

    return plans.map((item, index) => {
      const displayOptions = getPlanOptionsByFrequency(
        item,
        selectedFrequency,
        {
          includePrepaid: false,
          includeLifetimeFallback: true,
        }
      );

      if (displayOptions.length > 0) {
        return (
          <div className="card" key={index}>
            <React.Fragment>
              {renderPriceDetails(item, isYearlySelected)}
            </React.Fragment>
            {renderCardImage(item)}
            <div className="card-body">
              <h5>Benefits Include:</h5>
              <ul>
                {item.features?.map((feature) => (
                  <li key={feature.id}>{feature.name}</li>
                ))}
              </ul>
              <p>(**Registration fee: $0)</p>
              <button
                className="theme-button select-plan-btn"
                onClick={() => handlePlan(item)}
              >
                Select Plan
              </button>
            </div>
          </div>
        );
      }
      return null; // Return null if no valid package is found
    });
  };
  return (
    <>
      <div className="plan-select-mon-yer">
        <div className="form-check form-switch">
          <label
            className="form-check-label m"
            htmlFor="monthly"
            style={{ textAlign: 'left' }}
          >
            Monthly
          </label>
          <input
            className={`form-check-input ${!isPlan ? 'month' : 'yearly'}`}
            type="checkbox"
            id={!isPlan ? 'annually' : 'monthly'}
            onChange={() => setIsPlan(!isPlan)}
            checked={isPlan}
          />
          <label className="form-check-label" htmlFor="annually">
            Annually
          </label>
        </div>
      </div>
      <div
        className={
          data && data.length === 3 ? 'card-price ' : 'card-price pd-outer'
        }
      >
        {data && <>{renderPlanCards(data, isPlan)}</>}
      </div>
    </>
  );
};

export default PackagePlan;
